module.exports = __webpack_public_path__ + "img/v.2a467e68.png";